import { Component, input, OnInit, output } from '@angular/core';
import { Router } from '@angular/router';
import { SubmittedSummaryItems } from 'src/app/models/inspection.model';
import { CoreService } from 'src/app/services/core/core.service';
import { VehicleProvider } from 'src/app/services/providers/vehicle-provider/vehicle-provider';

@Component({
  selector: 'app-review-defects',
  templateUrl: './review-defects.component.html',
  styleUrls: ['./review-defects.component.scss'],
  standalone: false
})
export class ReviewDefectsComponent {

  submittedSummaryItems = input.required<SubmittedSummaryItems[]>();
  reviewDefects = output<SubmittedSummaryItems>();

  constructor(
    private readonly coreService: CoreService,
    private readonly vehicleProvider: VehicleProvider,
    private readonly router: Router
  ) { }

  get isMobileApp() {
    return this.coreService.isMobileApp;
  }

  async onReviewDefects(data: SubmittedSummaryItems) {
    const idx = await this.vehicleProvider.getVehicleIdx(data.icN_NO.toString());
    const vehicleData = await this.vehicleProvider.getVehicleByIcnNo(data.icN_NO.toString());
    if (!vehicleData || idx == undefined) {
      return;
    }

    this.vehicleProvider.setSelectedVehicle(vehicleData, idx);
    this.router.navigate(['/unroadworthy-defects', data.icN_NO]);
  }

}
